import { attributes, AttributesMixin, define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { Invoice } from "./invoice";

const NamedValue = attributes({
    name: String
});

const InsuranceCarrier = attributes({
    insuranceCarrierId: Number,
    insuranceCarrierName: String
});


export interface BoundPolicyInvoice extends AttributesMixin<typeof BoundPolicyInvoice> { }
@define
export class BoundPolicyInvoice extends Model {
    static endpoint = restfulIO('api/v1/ingest/invoices/linking');

    static attributes = {
        typeId: Number,
        createdBy: String,
        createdOn: Date,
        updatedBy: String,
        updatedOn: Date,
        isEligible: Boolean,
        ineligibleReasons: type([String]),
        assetDetails: Invoice
    };
}

export type BoundPolicyBuyer = InstanceType<typeof BoundPolicyBuyer>;

export const BoundPolicyBuyer = attributes({
    name: String,
    duns: String,
    invoices: [ BoundPolicyInvoice ],
    maxCreditLimit: type(Number).dontSave,
    policyId: type(String).dontSave,
    isSelected: type(Boolean).dontSave
});

export interface BoundPolicyApprovedLimits extends AttributesMixin<typeof BoundPolicyApprovedLimits> { }
@define
export class BoundPolicyApprovedLimits extends Model {

    static attributes = {
        policyId: String,
        debtors: [ BoundPolicyBuyer ],
        maxCreditLimit: Number
    };

    assignBuyers(): void {
        if (!this.debtors) return;
        this.debtors.forEach(buyer => {
            buyer.maxCreditLimit = this.maxCreditLimit;
            buyer.policyId = this.policyId;
        });
    }
}

export interface BoundPolicy extends AttributesMixin<typeof BoundPolicy> { }
@define
export class BoundPolicy extends Model {
    static endpoint = restfulIO('api/v1/ingest/invoices/linking/policies/bound');

    static attributes = {
        createdOn: Date,
        status: String,
        inceptionDate: Date,
        expiryDate: Date,
        name: String,
        policyTypeId: Number,
        coveredAssetTypeId: Number,
        carrierPolicyNumber: String,
        liabilityLimit: Number,
        premiumRate: Number,
        broker: NamedValue,
        policyInsuranceCarriers: [ InsuranceCarrier ]
    };
}
